import React from 'react';
import ScheduledMessageShowPage from '../ScheduledMessages/components/ScheduledMessageShowPage';

function AdminScheduledMessageShow() {
  return <ScheduledMessageShowPage mode="admin" />;
}

export default AdminScheduledMessageShow;
